export const GET_USER_DATA = 'yoga-adm/user/get-user-data';
export const LOGOUT = 'yoga-adm/user/logout';
export const GET_USER_PROFILE_PHOTO = 'yoga-web/user/get-user-profile-photo';
export const GET_NEW_TOKEN = 'yoga-web/user/get-new-token';
